
import React from 'react';
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import { formatCurrency } from './utils';
import { CrystalBallFormData } from './types';

interface ExpensesStepProps {
  formData: CrystalBallFormData;
  onInputChange: (field: string, value: string, category: 'expenses') => void;
  onNext: () => void;
}

const ExpensesStep: React.FC<ExpensesStepProps> = ({
  formData,
  onInputChange,
  onNext,
}) => {
  const calculateTotal = () => {
    return Object.values(formData.expenses).reduce(
      (sum, value) => sum + (parseFloat(value) || 0),
      0
    );
  };

  return (
    <div className="space-y-6">
      <div className="text-center space-y-2">
        <h3 className="text-2xl font-bold">Reality Check</h3>
        <p className="text-muted-foreground">
          Same life, new goals. Let's account for your expenses.
        </p>
      </div>

      <div className="space-y-4">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="space-y-2">
            <Label htmlFor="internetPhone">Internet & Phone</Label>
            <Input
              id="internetPhone"
              type="number"
              placeholder="Monthly cost"
              value={formData.expenses.internetPhone}
              onChange={(e) => onInputChange('internetPhone', e.target.value, 'expenses')}
            />
          </div>

          <div className="space-y-2">
            <Label htmlFor="techSoftware">Tech & Software</Label>
            <Input
              id="techSoftware"
              type="number"
              placeholder="Monthly cost"
              value={formData.expenses.techSoftware}
              onChange={(e) => onInputChange('techSoftware', e.target.value, 'expenses')}
            />
          </div>

          <div className="space-y-2">
            <Label htmlFor="workspaceOffice">Workspace/Office</Label>
            <Input
              id="workspaceOffice"
              type="number"
              placeholder="Monthly cost"
              value={formData.expenses.workspaceOffice}
              onChange={(e) => onInputChange('workspaceOffice', e.target.value, 'expenses')}
            />
          </div>

          <div className="space-y-2">
            <Label htmlFor="professionalDev">Professional Development</Label>
            <Input
              id="professionalDev"
              type="number"
              placeholder="Monthly cost"
              value={formData.expenses.professionalDev}
              onChange={(e) => onInputChange('professionalDev', e.target.value, 'expenses')}
            />
          </div>

          <div className="space-y-2">
            <Label htmlFor="healthcare">Healthcare Premium</Label>
            <Input
              id="healthcare"
              type="number"
              placeholder="Monthly cost"
              value={formData.expenses.healthcare}
              onChange={(e) => onInputChange('healthcare', e.target.value, 'expenses')}
            />
          </div>

          <div className="space-y-2">
            <Label htmlFor="transportation">Transportation</Label>
            <Input
              id="transportation"
              type="number"
              placeholder="Monthly cost"
              value={formData.expenses.transportation}
              onChange={(e) => onInputChange('transportation', e.target.value, 'expenses')}
            />
          </div>
        </div>

        <div className="pt-4 border-t">
          <p className="text-right text-lg font-semibold">
            Total Monthly Expenses: {formatCurrency(calculateTotal())}
          </p>
        </div>

        <Button 
          onClick={onNext}
          className="w-full"
        >
          Next Step
          <ArrowRight className="ml-2 h-4 w-4" />
        </Button>
      </div>
    </div>
  );
};

export default ExpensesStep;
